/**
 * NativeSelect — a token-styled native <select>. Added in #542 slice 2 after
 * its review caught the same select markup drifting between the Messages
 * page's filters and the compose modal's firm/contact pickers in one PR.
 * A native control on purpose: these are short, keyboard-friendly option
 * lists; no popover machinery earned.
 */

import * as React from "react";
import { cn } from "@/lib/utils";

export const NativeSelect = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      "h-9 rounded-md border border-input bg-background px-2 text-sm text-foreground",
      className,
    )}
    {...props}
  />
));
NativeSelect.displayName = "NativeSelect";
